import React, { useEffect, useMemo, useState } from 'react';
import {
  Card,
  Typography,
  Avatar,
  Space,
  Spin,
  Alert,
  theme,
  Row,
  Col,
  Tag,
  Tooltip,
  Divider,
  Button,
  Tabs,
  Badge,
  Progress,
  List,
  Empty,
  Skeleton,
} from 'antd';
import { UserOutlined, CalendarOutlined, DollarOutlined, ShoppingCartOutlined, InfoCircleOutlined, ReloadOutlined, SafetyCertificateOutlined, AppstoreOutlined, CreditCardOutlined, DatabaseOutlined, SettingOutlined, ArrowRightOutlined, QuestionCircleOutlined, } from '@ant-design/icons';
import { useAuth } from '../auth/AuthProvider';
import api from '../services/api';
import { useLanguage } from '../providers/LanguageProvider';
import useSubscriptions from 'src/hooks/useSubscriptions';
import { SearchOutlined, CloseOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import SectionCard from 'src/components/homePage/SectionCard';
import HomePageSubscriptions from 'src/components/homePage/HomePageSubscriptions';
import HomePageInvoiceProfiles from 'src/components/homePage/HomePageInvoiceProfiles';
import useInvoiceProfiles from 'src/hooks/useInvoiceProfiles';
import useSessions from 'src/hooks/useSessions';
import HomePageSessions from 'src/components/homePage/HomePageSessions';
import { useNavigate } from 'react-router';
import FastActions from 'src/components/homePage/FastActions';
const { Title, Text, Link } = Typography;
const { useToken } = theme;

export default function HomePage() {
  const { token } = useToken();
  const { t } = useLanguage();
  const { isAuthed } = useAuth();

  const [profile, setProfile] = useState<any>(null);

  const subscriptions = useSubscriptions();
  const invoiceProfiles = useInvoiceProfiles();
  const sessions = useSessions();
  const auth = useSelector((e: any) => e.auth)
  // ---------- Helpers ----------

  // ---------- Subscriptions fetch ----------
  useEffect(() => {
    subscriptions.fetchSubscriptions();
    invoiceProfiles.fetchInvoiceProfiles();
    sessions.fetchSessions(1, 3);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const fullName = [auth.account?.FirstName, auth.account?.LastName].filter(Boolean).join(' ');



  const profileImageUrl = profile?.Id ? `/api/v1/profile/upload/${profile.Id}` : null;



  // ---------- Data prep ----------
  const allSubs = Array.isArray(subscriptions.subscriptions) ? subscriptions.subscriptions : [];
  const activeProducts = allSubs.filter((s: any) => s.IsActive);
  const productsCount = activeProducts.length;

  // --- Storage (varsayılan: 0 / 15 GB) ---
  const usedGB = Number(profile?.StorageUsedGB ?? 0);
  const quotaGB = Number(profile?.StorageQuotaGB ?? 15);
  const usedPct = Math.min(100, Math.round((usedGB / Math.max(quotaGB, 0.0001)) * 100));

  const navigate = useNavigate()

  const ActionLink: React.FC<{ onClick?: () => void; href?: string; children: React.ReactNode }> = ({
    onClick,
    href,
    children,
  }) => (
    <Button
      type="text"
      size="small"
      onClick={onClick}
      href={href}
      icon={<ArrowRightOutlined />}
      style={{ borderRadius: 999 }}
    >
      {children}
    </Button>
  );

  // ---------- Render ----------
  return (
    <div >
      {/* Welcome */}
      <div
        style={{
          display: 'grid',
          placeItems: 'center',
          textAlign: 'center',
          paddingTop: 12,
          paddingBottom: 8,
        }}
      >
        <Avatar
          size={96}
          src={profileImageUrl || undefined}
          icon={<UserOutlined />}
        />
        <Title level={2} style={{ margin: 0, fontWeight: 600 }}>
          {t('WELCOME')} {fullName || t('USER')}
        </Title>
        <Text type="secondary">
          {t(
            'HOME_HERO_SUB',
          )}{' '}
          <a>{t('LEARN_MORE')}</a>
        </Text>
      </div>

      {/* Öneri/Tavsiye kartı */}




      {subscriptions.loading ?
        <Skeleton active paragraph={{ rows: 1 }} /> : <>

          {!subscriptions.subscriptions?.length ?

            <Card
              style={{
                maxWidth: 540,
                margin: '16px auto',
                borderRadius: 16,
                boxShadow: '0 1px 0 rgba(60,64,67,.08)',
              }}
              bodyStyle={{ padding: 16 }}
              extra={
                <Button
                  type="text"
                  size="small"
                  icon={<CloseOutlined />}
                />
              }
              title={
                <Space>
                  <Avatar size={28} style={{ background: '#1890ff' }}>
                    <QuestionCircleOutlined />
                  </Avatar>
                  <Text strong>{t('SUBSCRIPTION_HELP_TITLE', 'Abonelik almadınız mı?')}</Text>
                </Space>
              }
            >
              <Space direction="vertical" size={12} style={{ width: '100%' }}>
                <Text type="secondary">
                  {t('SUBSCRIPTION_HELP_DESC', 'Herhangi bir abonelik almadığınızı görüyorum. Kurulum yardımcısıyla başlamak ister misiniz?')}
                </Text>
                <Button onClick={() => navigate('/setup-wizard')} type="primary" shape="round">
                  {t('START_SETUP_GUIDE', 'Kurulum Yardımcısını Başlat')}
                </Button>
              </Space>
            </Card>

            : <Row gutter={[16, 16]}>
              {/* Sol kolon */}

              <Col xs={24} lg={24}>
                <HomePageInvoiceProfiles profiles={invoiceProfiles.invoiceProfiles} loading={invoiceProfiles.loading} error={invoiceProfiles.error} />

              </Col>

              <Col xs={24} lg={24}>
                <HomePageSessions sessions={sessions.sessions} loading={false} error={sessions.error} />
              </Col>



              <Col xs={24} lg={12}>
                <HomePageSubscriptions subscriptions={subscriptions.subscriptions} />
              </Col>


              {/* Sağ kolon */}
              <Col xs={24} lg={12}>
                <FastActions subscriptionsLength={subscriptions.subscriptions.length} />
              </Col>
            </Row>

          }


        </>
      }




    </div>
  );
}
